import _ from 'lodash';
import moment from 'moment';
import { extractQuetionnaireRefsFromConsent } from '../../../../../util/consentUtil';

const getTagValue = (resource, targetSystem) => {
  const tags = _.get(resource, 'meta.tag', []);
  const targetTag = tags.find((tag = {}) => tag.system === targetSystem);
  return _.get(targetTag, 'code', null);
};

const getConsentProject = resource =>
  getTagValue(resource, 'http://lifeomic.com/fhir/dataset');

const getConsentVersion = resource =>
  getTagValue(resource, 'http://lifeomic.com/fhir/questionnaire-version');

const getOriginalStatus = resource =>
  getTagValue(resource, 'http://lifeomic.com/fhir/original-status');

const getDate = resource => {
  const rawValue = _.get(resource, 'dateTime');
  if (!rawValue) return '';

  return moment(rawValue).format('MM/DD/YY hh:mm A');
};

const getSortValue = resource => {
  const rawValue = _.get(resource, 'dateTime');
  if (!rawValue) return 0;

  return moment(rawValue).unix();
};

export const parseConsent = resource => ({
  id: _.get(resource, 'id'),
  project: getConsentProject(resource),
  questionnaire:
    extractQuetionnaireRefsFromConsent(resource).questionnaire ||
    _.get(resource, 'active.questionnaire') ||
    null,
  questionnaireResponse: extractQuetionnaireRefsFromConsent(resource).response,
  version: getConsentVersion(resource),
  date: getDate(resource),
  sortValue: getSortValue(resource),
  name: _.get(resource, 'sourceReference.display'),
  status: _.get(resource, 'status'),
  originalStatus: getOriginalStatus(resource) || _.get(resource, 'status'),
});
